export default [
  {
    code: 'US',
    name: 'United States',
    officialName: 'United States of America',
    regions: [
      { code: 'AL', name: 'Alabama' },
      { code: 'AK', name: 'Alaska' },
      { code: 'AZ', name: 'Arizona' },
      { code: 'AR', name: 'Arkansas' },
      { code: 'CA', name: 'California' },
      { code: 'CO', name: 'Colorado' },
      { code: 'CT', name: 'Connecticut' },
      { code: 'DE', name: 'Delaware' },
      { code: 'FL', name: 'Florida' },
      { code: 'GA', name: 'Georgia' },
      { code: 'HI', name: 'Hawaii' },
      { code: 'ID', name: 'Idaho' },
      { code: 'IL', name: 'Illinois' },
      { code: 'IN', name: 'Indiana' },
      { code: 'IA', name: 'Iowa' },
      { code: 'KS', name: 'Kansas' },
      { code: 'KY', name: 'Kentucky' },
      { code: 'LA', name: 'Louisiana' },
      { code: 'ME', name: 'Maine' },
      { code: 'MD', name: 'Maryland' },
      { code: 'MA', name: 'Massachusetts' },
      { code: 'MI', name: 'Michigan' },
      { code: 'MN', name: 'Minnesota' },
      { code: 'MS', name: 'Mississippi' },
      { code: 'MO', name: 'Missouri' },
      { code: 'MT', name: 'Montana' },
      { code: 'NE', name: 'Nebraska' },
      { code: 'NV', name: 'Nevada' },
      { code: 'NH', name: 'New Hampshire' },
      { code: 'NJ', name: 'New Jersey' },
      { code: 'NM', name: 'New Mexico' },
      { code: 'NY', name: 'New York' },
      { code: 'NC', name: 'North Carolina' },
      { code: 'ND', name: 'North Dakota' },
      { code: 'OH', name: 'Ohio' },
      { code: 'OK', name: 'Oklahoma' },
      { code: 'OR', name: 'Oregon' },
      { code: 'PA', name: 'Pennsylvania' },
      { code: 'RI', name: 'Rhode Island' },
      { code: 'SC', name: 'South Carolina' },
      { code: 'SD', name: 'South Dakota' },
      { code: 'TN', name: 'Tennessee' },
      { code: 'TX', name: 'Texas' },
      { code: 'UT', name: 'Utah' },
      { code: 'VT', name: 'Vermont' },
      { code: 'VA', name: 'Virginia' },
      { code: 'WA', name: 'Washington' },
      { code: 'WV', name: 'West Virginia' },
      { code: 'WI', name: 'Wisconsin' },
      { code: 'WY', name: 'Wyoming' },
    ]
  },
  {
    code: 'CA',
    name: 'Canada',
    officialName: 'Canada',
    regions: [
      { code: "AB", name: "Alberta" },
      { code: "BC", name: "British Columbia" },
      { code: "MB", name: "Manitoba" },
      { code: "NB", name: "New Brunswick" },
      { code: "NL", name: "Newfoundland and Labrador" },
      { code: "NT", name: "Northwest Territories" },
      { code: "NS", name: "Nova Scotia" },
      { code: "NU", name: "Nunavut" },
      { code: "ON", name: "Ontario" },
      { code: "PE", name: "Prince Edward Island" },
      { code: "QC", name: "Quebec" },
      { code: "SK", name: "Saskatchewan" },
      { code: "YT", name: "Yukon" }
    ]
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    officialName: 'Islamic Republic of Afghanistan'
  },
  {
    code: 'AX',
    name: 'Åland Islands',
    officialName: 'Åland Islands'
  },
  {
    code: 'AL',
    name: 'Albania',
    officialName: 'Republic of Albania'
  },
  {
    code: 'DZ',
    name: 'Algeria',
    officialName: "People's Democratic Republic of Algeria"
  },
  {
    code: 'AS',
    name: 'American Samoa',
    officialName: 'American Samoa'
  },
  {
    code: 'AD',
    name: 'Andorra',
    officialName: 'Principality of Andorra'
  },
  {
    code: 'AO',
    name: 'Angola',
    officialName: 'Republic of Angola'
  },
  {
    code: 'AI',
    name: 'Anguilla',
    officialName: 'Anguilla'
  },
  {
    code: 'AQ',
    name: 'Antarctica',
    officialName: 'Antarctica'
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    officialName: 'Antigua and Barbuda'
  },
  {
    code: 'AR',
    name: 'Argentina',
    officialName: 'Argentine Republic'
  },
  {
    code: 'AM',
    name: 'Armenia',
    officialName: 'Republic of Armenia'
  },
  {
    code: 'AW',
    name: 'Aruba',
    officialName: 'Aruba'
  },
  {
    code: 'AU',
    name: 'Australia',
    officialName: 'Commonwealth of Australia'
  },
  {
    code: 'AT',
    name: 'Austria',
    officialName: 'Republic of Austria'
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    officialName: 'Republic of Azerbaijan'
  },
  {
    code: 'BS',
    name: 'Bahamas',
    officialName: 'Commonwealth of the Bahamas'
  },
  {
    code: 'BH',
    name: 'Bahrain',
    officialName: 'Kingdom of Bahrain'
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    officialName: "People's Republic of Bangladesh"
  },
  {
    code: 'BB',
    name: 'Barbados',
    officialName: 'Barbados'
  },
  {
    code: 'BY',
    name: 'Belarus',
    officialName: 'Republic of Belarus'
  },
  {
    code: 'BE',
    name: 'Belgium',
    officialName: 'Kingdom of Belgium'
  },
  {
    code: 'BZ',
    name: 'Belize',
    officialName: 'Belize'
  },
  {
    code: 'BJ',
    name: 'Benin',
    officialName: 'Republic of Benin'
  },
  {
    code: 'BM',
    name: 'Bermuda',
    officialName: 'Bermuda'
  },
  {
    code: 'BT',
    name: 'Bhutan',
    officialName: 'Kingdom of Bhutan'
  },
  {
    code: 'BO',
    name: 'Bolivia',
    officialName: 'Plurinational State of Bolivia'
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    officialName: 'Bosnia and Herzegovina'
  },
  {
    code: 'BW',
    name: 'Botswana',
    officialName: 'Republic of Botswana'
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
    officialName: 'Bouvet Island'
  },
  {
    code: 'BR',
    name: 'Brazil',
    officialName: 'Federative Republic of Brazil'
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    officialName: 'British Indian Ocean Territory'
  },
  {
    code: 'VG',
    name: 'British Virgin Islands',
    officialName: 'Virgin Islands'
  },
  {
    code: 'BN',
    name: 'Brunei',
    officialName: 'Nation of Brunei, Abode of Peace'
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    officialName: 'Republic of Bulgaria'
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    officialName: 'Burkina Faso'
  },
  {
    code: 'BI',
    name: 'Burundi',
    officialName: 'Republic of Burundi'
  },
  {
    code: 'KH',
    name: 'Cambodia',
    officialName: 'Kingdom of Cambodia'
  },
  {
    code: 'CM',
    name: 'Cameroon',
    officialName: 'Republic of Cameroon'
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    officialName: 'Republic of Cabo Verde'
  },
  {
    code: 'BQ',
    name: 'Caribbean Netherlands',
    officialName: 'Bonaire, Sint Eustatius and Saba'
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    officialName: 'Cayman Islands'
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    officialName: 'Central African Republic'
  },
  {
    code: 'TD',
    name: 'Chad',
    officialName: 'Republic of Chad',
    isRestricted: true
  },
  {
    code: 'CL',
    name: 'Chile',
    officialName: 'Republic of Chile'
  },
  {
    code: 'CN',
    name: 'China',
    officialName: "People's Republic of China"
  },
  {
    code: 'CX',
    name: 'Christmas Island',
    officialName: 'Territory of Christmas Island'
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    officialName: 'Territory of the Cocos (Keeling) Islands'
  },
  {
    code: 'CO',
    name: 'Colombia',
    officialName: 'Republic of Colombia'
  },
  {
    code: 'KM',
    name: 'Comoros',
    officialName: 'Union of the Comoros'
  },
  {
    code: 'CK',
    name: 'Cook Islands',
    officialName: 'Cook Islands'
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    officialName: 'Republic of Costa Rica'
  },
  {
    code: 'HR',
    name: 'Croatia',
    officialName: 'Republic of Croatia'
  },
  {
    code: 'CU',
    name: 'Cuba',
    officialName: 'Republic of Cuba'
  },
  {
    code: 'CW',
    name: 'Curaçao',
    officialName: 'Country of Curaçao'
  },
  {
    code: 'CY',
    name: 'Cyprus',
    officialName: 'Republic of Cyprus'
  },
  {
    code: 'CZ',
    name: 'Czechia',
    officialName: 'Czech Republic'
  },
  {
    code: 'DK',
    name: 'Denmark',
    officialName: 'Kingdom of Denmark'
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    officialName: 'Republic of Djibouti'
  },
  {
    code: 'DM',
    name: 'Dominica',
    officialName: 'Commonwealth of Dominica'
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    officialName: 'Dominican Republic'
  },
  {
    code: 'CD',
    name: 'DR Congo',
    officialName: 'Democratic Republic of the Congo',
    isRestricted: true
  },
  {
    code: 'EC',
    name: 'Ecuador',
    officialName: 'Republic of Ecuador'
  },
  {
    code: 'EG',
    name: 'Egypt',
    officialName: 'Arab Republic of Egypt'
  },
  {
    code: 'SV',
    name: 'El Salvador',
    officialName: 'Republic of El Salvador'
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    officialName: 'Republic of Equatorial Guinea'
  },
  {
    code: 'ER',
    name: 'Eritrea',
    officialName: 'State of Eritrea',
    isRestricted: true
  },
  {
    code: 'EE',
    name: 'Estonia',
    officialName: 'Republic of Estonia'
  },
  {
    code: 'SZ',
    name: 'Eswatini',
    officialName: 'Kingdom of Eswatini'
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    officialName: 'Federal Democratic Republic of Ethiopia'
  },
  {
    code: 'FK',
    name: 'Falkland Islands',
    officialName: 'Falkland Islands'
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    officialName: 'Faroe Islands'
  },
  {
    code: 'FJ',
    name: 'Fiji',
    officialName: 'Republic of Fiji'
  },
  {
    code: 'FI',
    name: 'Finland',
    officialName: 'Republic of Finland'
  },
  {
    code: 'FR',
    name: 'France',
    officialName: 'French Republic'
  },
  {
    code: 'GF',
    name: 'French Guiana',
    officialName: 'Guiana'
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    officialName: 'French Polynesia'
  },
  {
    code: 'TF',
    name: 'French Southern and Antarctic Lands',
    officialName: 'Territory of the French Southern and Antarctic Lands'
  },
  {
    code: 'GA',
    name: 'Gabon',
    officialName: 'Gabonese Republic'
  },
  {
    code: 'GM',
    name: 'Gambia',
    officialName: 'Republic of the Gambia'
  },
  {
    code: 'GE',
    name: 'Georgia',
    officialName: 'Georgia'
  },
  {
    code: 'DE',
    name: 'Germany',
    officialName: 'Federal Republic of Germany'
  },
  {
    code: 'GH',
    name: 'Ghana',
    officialName: 'Republic of Ghana'
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    officialName: 'Gibraltar'
  },
  {
    code: 'GR',
    name: 'Greece',
    officialName: 'Hellenic Republic'
  },
  {
    code: 'GL',
    name: 'Greenland',
    officialName: 'Greenland'
  },
  {
    code: 'GD',
    name: 'Grenada',
    officialName: 'Grenada'
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    officialName: 'Guadeloupe'
  },
  {
    code: 'GU',
    name: 'Guam',
    officialName: 'Guam'
  },
  {
    code: 'GT',
    name: 'Guatemala',
    officialName: 'Republic of Guatemala'
  },
  {
    code: 'GG',
    name: 'Guernsey',
    officialName: 'Bailiwick of Guernsey'
  },
  {
    code: 'GN',
    name: 'Guinea',
    officialName: 'Republic of Guinea'
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    officialName: 'Republic of Guinea-Bissau'
  },
  {
    code: 'GY',
    name: 'Guyana',
    officialName: 'Co-operative Republic of Guyana'
  },
  {
    code: 'HT',
    name: 'Haiti',
    officialName: 'Republic of Haiti',
    isRestricted: true
  },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
    officialName: 'Heard Island and McDonald Islands'
  },
  {
    code: 'HN',
    name: 'Honduras',
    officialName: 'Republic of Honduras'
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    officialName:
      "Hong Kong Special Administrative Region of the People's Republic of China"
  },
  {
    code: 'HU',
    name: 'Hungary',
    officialName: 'Hungary'
  },
  {
    code: 'IS',
    name: 'Iceland',
    officialName: 'Iceland'
  },
  {
    code: 'IN',
    name: 'India',
    officialName: 'Republic of India'
  },
  {
    code: 'ID',
    name: 'Indonesia',
    officialName: 'Republic of Indonesia'
  },
  {
    code: 'IR',
    name: 'Iran',
    officialName: 'Islamic Republic of Iran'
  },
  {
    code: 'IQ',
    name: 'Iraq',
    officialName: 'Republic of Iraq'
  },
  {
    code: 'IE',
    name: 'Ireland',
    officialName: 'Republic of Ireland'
  },
  {
    code: 'IM',
    name: 'Isle of Man',
    officialName: 'Isle of Man'
  },
  {
    code: 'IL',
    name: 'Israel',
    officialName: 'State of Israel'
  },
  {
    code: 'IT',
    name: 'Italy',
    officialName: 'Italian Republic'
  },
  {
    code: 'CI',
    name: 'Ivory Coast',
    officialName: "Republic of Côte d'Ivoire"
  },
  {
    code: 'JM',
    name: 'Jamaica',
    officialName: 'Jamaica'
  },
  {
    code: 'JP',
    name: 'Japan',
    officialName: 'Japan'
  },
  {
    code: 'JE',
    name: 'Jersey',
    officialName: 'Bailiwick of Jersey'
  },
  {
    code: 'JO',
    name: 'Jordan',
    officialName: 'Hashemite Kingdom of Jordan'
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    officialName: 'Republic of Kazakhstan'
  },
  {
    code: 'KE',
    name: 'Kenya',
    officialName: 'Republic of Kenya'
  },
  {
    code: 'KI',
    name: 'Kiribati',
    officialName: 'Independent and Sovereign Republic of Kiribati'
  },
  {
    code: 'XK',
    name: 'Kosovo',
    officialName: 'Republic of Kosovo'
  },
  {
    code: 'KW',
    name: 'Kuwait',
    officialName: 'State of Kuwait'
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    officialName: 'Kyrgyz Republic'
  },
  {
    code: 'LA',
    name: 'Laos',
    officialName: "Lao People's Democratic Republic"
  },
  {
    code: 'LV',
    name: 'Latvia',
    officialName: 'Republic of Latvia'
  },
  {
    code: 'LB',
    name: 'Lebanon',
    officialName: 'Lebanese Republic'
  },
  {
    code: 'LS',
    name: 'Lesotho',
    officialName: 'Kingdom of Lesotho'
  },
  {
    code: 'LR',
    name: 'Liberia',
    officialName: 'Republic of Liberia'
  },
  {
    code: 'LY',
    name: 'Libya',
    officialName: 'State of Libya',
    isRestricted: true
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    officialName: 'Principality of Liechtenstein'
  },
  {
    code: 'LT',
    name: 'Lithuania',
    officialName: 'Republic of Lithuania'
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    officialName: 'Grand Duchy of Luxembourg'
  },
  {
    code: 'MO',
    name: 'Macau',
    officialName:
      "Macao Special Administrative Region of the People's Republic of China"
  },
  {
    code: 'MG',
    name: 'Madagascar',
    officialName: 'Republic of Madagascar'
  },
  {
    code: 'MW',
    name: 'Malawi',
    officialName: 'Republic of Malawi'
  },
  {
    code: 'MY',
    name: 'Malaysia',
    officialName: 'Malaysia'
  },
  {
    code: 'MV',
    name: 'Maldives',
    officialName: 'Republic of the Maldives'
  },
  {
    code: 'ML',
    name: 'Mali',
    officialName: 'Republic of Mali'
  },
  {
    code: 'MT',
    name: 'Malta',
    officialName: 'Republic of Malta'
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    officialName: 'Republic of the Marshall Islands'
  },
  {
    code: 'MQ',
    name: 'Martinique',
    officialName: 'Martinique'
  },
  {
    code: 'MR',
    name: 'Mauritania',
    officialName: 'Islamic Republic of Mauritania'
  },
  {
    code: 'MU',
    name: 'Mauritius',
    officialName: 'Republic of Mauritius'
  },
  {
    code: 'YT',
    name: 'Mayotte',
    officialName: 'Department of Mayotte'
  },
  {
    code: 'MX',
    name: 'Mexico',
    officialName: 'United Mexican States'
  },
  {
    code: 'FM',
    name: 'Micronesia',
    officialName: 'Federated States of Micronesia'
  },
  {
    code: 'MD',
    name: 'Moldova',
    officialName: 'Republic of Moldova'
  },
  {
    code: 'MC',
    name: 'Monaco',
    officialName: 'Principality of Monaco'
  },
  {
    code: 'MN',
    name: 'Mongolia',
    officialName: 'Mongolia'
  },
  {
    code: 'ME',
    name: 'Montenegro',
    officialName: 'Montenegro'
  },
  {
    code: 'MS',
    name: 'Montserrat',
    officialName: 'Montserrat'
  },
  {
    code: 'MA',
    name: 'Morocco',
    officialName: 'Kingdom of Morocco'
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    officialName: 'Republic of Mozambique'
  },
  {
    code: 'MM',
    name: 'Myanmar',
    officialName: 'Republic of the Union of Myanmar'
  },
  {
    code: 'NA',
    name: 'Namibia',
    officialName: 'Republic of Namibia'
  },
  {
    code: 'NR',
    name: 'Nauru',
    officialName: 'Republic of Nauru'
  },
  {
    code: 'NP',
    name: 'Nepal',
    officialName: 'Federal Democratic Republic of Nepal'
  },
  {
    code: 'NL',
    name: 'Netherlands',
    officialName: 'Kingdom of the Netherlands'
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    officialName: 'New Caledonia'
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    officialName: 'New Zealand'
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    officialName: 'Republic of Nicaragua'
  },
  {
    code: 'NE',
    name: 'Niger',
    officialName: 'Republic of Niger'
  },
  {
    code: 'NG',
    name: 'Nigeria',
    officialName: 'Federal Republic of Nigeria'
  },
  {
    code: 'NU',
    name: 'Niue',
    officialName: 'Niue'
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
    officialName: 'Territory of Norfolk Island'
  },
  {
    code: 'KP',
    name: 'North Korea',
    officialName: "Democratic People's Republic of Korea",
    isRestricted: true
  },
  {
    code: 'MK',
    name: 'North Macedonia',
    officialName: 'Republic of North Macedonia'
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    officialName: 'Commonwealth of the Northern Mariana Islands'
  },
  {
    code: 'NO',
    name: 'Norway',
    officialName: 'Kingdom of Norway'
  },
  {
    code: 'OM',
    name: 'Oman',
    officialName: 'Sultanate of Oman'
  },
  {
    code: 'PK',
    name: 'Pakistan',
    officialName: 'Islamic Republic of Pakistan'
  },
  {
    code: 'PW',
    name: 'Palau',
    officialName: 'Republic of Palau'
  },
  {
    code: 'PS',
    name: 'Palestine',
    officialName: 'State of Palestine'
  },
  {
    code: 'PA',
    name: 'Panama',
    officialName: 'Republic of Panama'
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    officialName: 'Independent State of Papua New Guinea'
  },
  {
    code: 'PY',
    name: 'Paraguay',
    officialName: 'Republic of Paraguay'
  },
  {
    code: 'PE',
    name: 'Peru',
    officialName: 'Republic of Peru'
  },
  {
    code: 'PH',
    name: 'Philippines',
    officialName: 'Republic of the Philippines'
  },
  {
    code: 'PN',
    name: 'Pitcairn Islands',
    officialName: 'Pitcairn Group of Islands'
  },
  {
    code: 'PL',
    name: 'Poland',
    officialName: 'Republic of Poland'
  },
  {
    code: 'PT',
    name: 'Portugal',
    officialName: 'Portuguese Republic'
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    officialName: 'Commonwealth of Puerto Rico'
  },
  {
    code: 'QA',
    name: 'Qatar',
    officialName: 'State of Qatar'
  },
  {
    code: 'CG',
    name: 'Republic of the Congo',
    officialName: 'Republic of the Congo'
  },
  {
    code: 'RE',
    name: 'Réunion',
    officialName: 'Réunion Island'
  },
  {
    code: 'RO',
    name: 'Romania',
    officialName: 'Romania'
  },
  {
    code: 'RU',
    name: 'Russia',
    officialName: 'Russian Federation'
  },
  {
    code: 'RW',
    name: 'Rwanda',
    officialName: 'Republic of Rwanda'
  },
  {
    code: 'BL',
    name: 'Saint Barthélemy',
    officialName: 'Collectivity of Saint Barthélemy'
  },
  {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    officialName: 'Saint Helena, Ascension and Tristan da Cunha'
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    officialName: 'Federation of Saint Christopher and Nevis'
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    officialName: 'Saint Lucia'
  },
  {
    code: 'MF',
    name: 'Saint Martin',
    officialName: 'Saint Martin'
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    officialName: 'Saint Pierre and Miquelon'
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    officialName: 'Saint Vincent and the Grenadines'
  },
  {
    code: 'WS',
    name: 'Samoa',
    officialName: 'Independent State of Samoa'
  },
  {
    code: 'SM',
    name: 'San Marino',
    officialName: 'Republic of San Marino'
  },
  {
    code: 'ST',
    name: 'São Tomé and Príncipe',
    officialName: 'Democratic Republic of São Tomé and Príncipe'
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    officialName: 'Kingdom of Saudi Arabia'
  },
  {
    code: 'SN',
    name: 'Senegal',
    officialName: 'Republic of Senegal'
  },
  {
    code: 'RS',
    name: 'Serbia',
    officialName: 'Republic of Serbia'
  },
  {
    code: 'SC',
    name: 'Seychelles',
    officialName: 'Republic of Seychelles'
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    officialName: 'Republic of Sierra Leone'
  },
  {
    code: 'SG',
    name: 'Singapore',
    officialName: 'Republic of Singapore'
  },
  {
    code: 'SX',
    name: 'Sint Maarten',
    officialName: 'Sint Maarten'
  },
  {
    code: 'SK',
    name: 'Slovakia',
    officialName: 'Slovak Republic'
  },
  {
    code: 'SI',
    name: 'Slovenia',
    officialName: 'Republic of Slovenia'
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    officialName: 'Solomon Islands'
  },
  {
    code: 'SO',
    name: 'Somalia',
    officialName: 'Federal Republic of Somalia',
    isRestricted: true
  },
  {
    code: 'ZA',
    name: 'South Africa',
    officialName: 'Republic of South Africa'
  },
  {
    code: 'GS',
    name: 'South Georgia',
    officialName: 'South Georgia and the South Sandwich Islands'
  },
  {
    code: 'KR',
    name: 'South Korea',
    officialName: 'Republic of Korea'
  },
  {
    code: 'SS',
    name: 'South Sudan',
    officialName: 'Republic of South Sudan',
    isRestricted: true
  },
  {
    code: 'ES',
    name: 'Spain',
    officialName: 'Kingdom of Spain'
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    officialName: 'Democratic Socialist Republic of Sri Lanka'
  },
  {
    code: 'SD',
    name: 'Sudan',
    officialName: 'Republic of the Sudan'
  },
  {
    code: 'SR',
    name: 'Suriname',
    officialName: 'Republic of Suriname'
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    officialName: 'Svalbard og Jan Mayen'
  },
  {
    code: 'SE',
    name: 'Sweden',
    officialName: 'Kingdom of Sweden'
  },
  {
    code: 'CH',
    name: 'Switzerland',
    officialName: 'Swiss Confederation'
  },
  {
    code: 'SY',
    name: 'Syria',
    officialName: 'Syrian Arab Republic',
    isRestricted: true
  },
  {
    code: 'TW',
    name: 'Taiwan',
    officialName: 'Republic of China (Taiwan)'
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    officialName: 'Republic of Tajikistan'
  },
  {
    code: 'TZ',
    name: 'Tanzania',
    officialName: 'United Republic of Tanzania'
  },
  {
    code: 'TH',
    name: 'Thailand',
    officialName: 'Kingdom of Thailand'
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    officialName: 'Democratic Republic of Timor-Leste'
  },
  {
    code: 'TG',
    name: 'Togo',
    officialName: 'Togolese Republic'
  },
  {
    code: 'TK',
    name: 'Tokelau',
    officialName: 'Tokelau'
  },
  {
    code: 'TO',
    name: 'Tonga',
    officialName: 'Kingdom of Tonga'
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    officialName: 'Republic of Trinidad and Tobago'
  },
  {
    code: 'TN',
    name: 'Tunisia',
    officialName: 'Tunisian Republic'
  },
  {
    code: 'TR',
    name: 'Turkey',
    officialName: 'Republic of Turkey'
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    officialName: 'Turkmenistan'
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    officialName: 'Turks and Caicos Islands'
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    officialName: 'Tuvalu'
  },
  {
    code: 'UG',
    name: 'Uganda',
    officialName: 'Republic of Uganda'
  },
  {
    code: 'UA',
    name: 'Ukraine',
    officialName: 'Ukraine'
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    officialName: 'United Arab Emirates'
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    officialName: 'United Kingdom of Great Britain and Northern Ireland'
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    officialName: 'United States Minor Outlying Islands'
  },
  {
    code: 'VI',
    name: 'United States Virgin Islands',
    officialName: 'Virgin Islands of the United States'
  },
  {
    code: 'UY',
    name: 'Uruguay',
    officialName: 'Oriental Republic of Uruguay'
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    officialName: 'Republic of Uzbekistan'
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    officialName: 'Republic of Vanuatu'
  },
  {
    code: 'VA',
    name: 'Vatican City',
    officialName: 'Vatican City State'
  },
  {
    code: 'VE',
    name: 'Venezuela',
    officialName: 'Bolivarian Republic of Venezuela'
  },
  {
    code: 'VN',
    name: 'Vietnam',
    officialName: 'Socialist Republic of Vietnam'
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
    officialName: 'Territory of the Wallis and Futuna Islands'
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    officialName: 'Sahrawi Arab Democratic Republic'
  },
  {
    code: 'YE',
    name: 'Yemen',
    officialName: 'Republic of Yemen',
    isRestricted: true
  },
  {
    code: 'ZM',
    name: 'Zambia',
    officialName: 'Republic of Zambia'
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    officialName: 'Republic of Zimbabwe'
  }
];



// WEBPACK FOOTER //
// ./src/App/components/common/countries.js